module.exports = __webpack_public_path__ + "img/samsung_QE55Q70AATXXH.e7a5301.jpg";